import _ from 'lodash';

import { getReactionChatUserId, getReactionEmoji } from '../TeamChat.utils';

export const groupReactions = reactions => {
  if (_.isEmpty(reactions)) {
    return [];
  }

  const grouped = reactions.reduce((acc, reaction) => {
    const emoji = getReactionEmoji(reaction);

    if (!emoji) {
      return acc;
    }

    const chatUserId = getReactionChatUserId(reaction);
    const existing = acc.get(emoji) ?? { emoji, count: 0, chatUserIds: [] };

    existing.count += 1;

    if (chatUserId && !existing.chatUserIds.includes(chatUserId)) {
      existing.chatUserIds.push(chatUserId);
    }

    acc.set(emoji, existing);

    return acc;
  }, new Map());

  return Array.from(grouped.values());
};
